import { Pipe, PipeTransform } from '@angular/core';
import { humanFileSize } from '@my-aon/utils';

@Pipe({
    name: 'humanizeBytes',
    standalone: true,
})
export class HumanizeBytesPipe implements PipeTransform {

    transform(value: number, si: boolean = false, dp?: number): any {
        return humanFileSize(value, si, dp);
    }

}
